export const ivaValues = [
    { value: 21, label: "21%" },
    { value: 10.5, label: "10,5%" },
    { value: 0, label: "0%" }
];

export const currencyValues = [
  { value: 1, label: "ARS" },
  { value: 2, label: "USD" }
];

export const paymentMethods = {
    0: "Saldo del cliente",
    1: "Efectivo",
    2: "Transferencia",
    3: "Nota de crédito",
    4: "Retención IIBB",
    5: "Retención IVA",
    6: "Retención Ganancia",
    7: "Cheque"
};